import consumer from 'channels/consumer'

class CertificateSubscription {
  constructor (quizId) {
    this.quizId = quizId
  }

  setup () {
    consumer.subscriptions.create({
      channel: 'CertificateChannel',
      quiz_id: this.quizId
    }, {
      received(data) {
        const button = document.querySelector('[data-track-certificate]')
        const link = document.querySelector('#download-certificate-btn')

        button.classList.add('d-none')
        link.href = data.certificate_path
        link.classList.remove('d-none')
      }
    });
  }
}

function ready() {
  const button = document.querySelector('[data-track-certificate]')
  if (button) {
    const quizId = button.dataset.trackCertificate
    const subscription = new CertificateSubscription(quizId)
    subscription.setup()
  }
}

document.addEventListener('turbolinks:load', ready);
